import { BooleanField, Show, TabbedShowLayout, TextField, useGetIdentity, useGetOne, useRefresh, useTranslate } from "react-admin"
import { HubConnection } from "@microsoft/signalr"
import MailServerShowActions from "./mailServiceConfig/MailServerShowActions"
import { Divider } from "@mui/material"
import textModelEmailTemplate from "../fixtures/textModelEmailTemplate"
import EmailTextShow from "./EmailTextShow"

interface IProps {
  connection?: HubConnection
}

const UserMailServiceConfig = ({connection}: IProps) => {

  const translate = useTranslate()
  const refresh = useRefresh()
  const { data: identity, isLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})

  connection?.on("UserUpdated", (user) => {
    refresh()
  })

  if(isLoading || !identity || userLoading) return null

  return (
    <Show resource='users' id={identity.id} title={translate("resources.mailServiceConfig.name", {smart_count: 1})} actions={false} >
      <TabbedShowLayout record={user.textModelEmail ? user : {...user, textModelEmail: textModelEmailTemplate}}>
        <TabbedShowLayout.Tab label="resources.mailServiceConfig.name">
          <TextField source="mailServiceConfig.email" label="resources.mailServiceConfig.email" emptyText="-" />
          <TextField source="mailServiceConfig.sender" label="resources.mailServiceConfig.sender" emptyText="-" />
          <TextField source="mailServiceConfig.username" label="resources.mailServiceConfig.userName" emptyText="-" />
          <TextField source="mailServiceConfig.host" label="resources.mailServiceConfig.host" emptyText="-" />
          <TextField source="mailServiceConfig.port" label="resources.mailServiceConfig.port" emptyText="-" />
          <BooleanField source="mailServiceConfig.useSsl" label="resources.mailServiceConfig.useSsl" emptyText="-" />
          <Divider />
          <MailServerShowActions />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="resources.textTemplates.textModelEmail" >
          <EmailTextShow />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>

  )
}

export default UserMailServiceConfig